import { type UseQueryResult, useQuery } from 'react-query';
import {
  TaxCertificationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationListViewDTO,
} from '../../services/wealthlane-customer-services';

const useGetTaxCertificationFormList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_TaxCertificationFormDTO_TaxCetificationListViewDTO[] | undefined,
  unknown
> => {
  const taxCertificationFormList = useQuery(['getTaxCertificationFormList'], async () => {
    return await handleRequest(
      TaxCertificationService.getApiCustomerApiAppTaxCertificationTaxCertificationFormList()
    );
  }, {
    cacheTime: 1000 * 60 * 2, // Reduced cache time to 2 minutes
    staleTime: 0, // Data becomes stale immediately to ensure fresh data
  });
  return taxCertificationFormList;
};

export default useGetTaxCertificationFormList;
